import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { IImageProps, IImageStyleProps, IImageStyles } from '/druid/Image.types';
import { ImageBase } from '/druid/Image.base';
import { getStyles } from '/druid/Image.styles';

export const Image: React.FunctionComponent<IImageProps> = styled<IImageProps, IImageStyleProps, IImageStyles>(
  ImageBase,
  getStyles,
  undefined,
  {
    scope: 'Image',
  },
  true,
);
